import { DynamicResult, DynamicService } from 'utils/service';
import {
    API_PHARMACIES,
    IPharmacyDrugsByPharmacy,
    Pharmacy,
} from './models';

export * from './models';

class Service extends DynamicService<Pharmacy> {
    getDrugsByPharmacy = async () => {

        const {data} = await this.engine.get<DynamicResult<IPharmacyDrugsByPharmacy>>(API_PHARMACIES.GET_ALL_DRUGS_BY_PHARMACY, {
            params: {
                orderBy: 'entryYearMonth desc, totalSent desc',
                count: true,
            }
        });

        return data
    }
}
export const ServicePharmacies = new Service({
  mainField: 'id',
  getAll: API_PHARMACIES.GET_ALL_DYNAMIC,
  post: API_PHARMACIES.POST,
  patch: API_PHARMACIES.PATCH,
  delete: API_PHARMACIES.DELETE,
});

